import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Modal from 'js/components/modal';

const DeleteReportModal = (props) => {
  const { className, mounted, onDismiss, onConfirm, isActive } = props;
  const { t } = useTranslation();
  return (
    <Modal
      className={classnames('delete-report-modal', className)}
      onClickCancel={onDismiss}
      titleText={t('components.DeleteReportModal.title')}
      mounted={mounted}
      underlayClickExits={false}
      verticallyCenter
      focusTrapPaused
    >
      <h2>{t('components.DeleteReportModal.title')}</h2>
      <p>{t('components.DeleteReportModal.text')}</p>
      <div className="button-bar">
        <button
          className="button-link-appearance"
          disabled={isActive}
          onClick={onDismiss}
        >
          {t('common.cancel')}
        </button>
        <button
          className="button button-highlight"
          disabled={isActive}
          onClick={onConfirm}
        >
          {isActive ? t('common.deleting') : t('common.delete')}
        </button>
      </div>
    </Modal>
  );
};

DeleteReportModal.defaultProps = {
  mounted: false,
  isActive: false,
};

DeleteReportModal.propTypes = {
  className: PropTypes.string,
  mounted: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
};

export default DeleteReportModal;
